import { Formik } from "formik";
import * as Yup from "yup";
import {  Button, Form, Modal } from "react-bootstrap";
import { LoadingSpinner } from "../generalLayout";
import {
  provinces,
  states,
} from "../../constants/provincesAndStates";
import { useState } from "react";

// form validation schema (with Yup)
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Please enter a name"),
  country: Yup.string().required("Please choose a country"),
  street: Yup.string().required("Please enter a street"),
  city: Yup.string().required("Please enter a city"),
  province: Yup.string().required("Please enter a province"),
  postalCode: Yup.string().when("country", {
    is: (country) => country && country === "Canada",
    then: () =>
      Yup.string().matches(
        /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, //regex Canadian postal code
        "Please enter a valid Canadian postal code"
      ).required("Please enter a postal/zip code"),
    otherwise: () =>
      Yup.string().matches(
        /^\d{5}(?:[-\s]\d{4})?$/, //regex US zip code
        "Please enter a valid U.S. zip code"
      ).required("Please enter a postal/zip code"),
  }),
});

export default function AddressFormModal(props) {
  // displays a form for entering/updating delivery address information

  const [country, setCountry] = useState(props?.data?.address?.country || "Canada");
  const [show, setShow] = useState(true);

  const formFields = [
    { name: "name", label: "Name", type: "text" },
    {
      name: "country",
      label: "Country",
      type: "select",
      options: ["Canada", "USA"],
    },
    { name: "street", label: "Street", type: "text" },
    { name: "city", label: "City", type: "text" },
    {
      name: "province",
      label: country === "Canada" ? "Province" : "State",
      type: "select",
      options: (country === "Canada") ? provinces : (country === "USA") ? states : [],
    },
    {
      name: "postalCode",
      label: country === "Canada" ? "Postal Code" : "Zip Code",
      type: "text",
    },
  ];

  return (
    <Modal
      size="md"
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>Delivery Address</span>

          <Button
            variant="light"
            onClick={() => {
              setShow(false);
              props.handleCancelClick();
            }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: props?.data?.name || "",
            country: props?.data?.address?.country || "",
            street: props?.data?.address?.street || "",
            city: props?.data?.address?.city || "",
            province: props?.data?.address?.province || "",
            postalCode: props?.data?.address?.postalCode || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            props.handleSubmitClick(values);
            setSubmitting(false);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {formFields.map((field, idx) => (
                <Form.Group key={idx} className="mb-3" controlId={field.name}>
                  <Form.Label
                    className={field.name === "password" ? "mt-4" : ""}
                  >
                    {field.label}
                  </Form.Label>
                  {/* select with dropdown */}
                  {field.type === "select" ? (
                    <Form.Select
                      size="md"
                      aria-label="Default select example"
                      name={field.name}
                      value={values[field.name]}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                      onChange={(event) => {
                        if (field.name === "country") {
                          setCountry(event.target.value);
                        }
                        handleChange(event);
                      }}
                    >
                   <option value="" >
          Please Select
        </option>
                      {field.options.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control //regular field
                      type={field.type}
                      name={field.name}
                      value={values[field.name]}
                      onChange={handleChange}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                    />
                  )}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}
              <Button type="submit">
                {isSubmitting && (
                  <LoadingSpinner
                    button={true}
                    variant="primary"
                  />
                )}{" "}
               Save
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
